import React from "react";
import { observer } from "mobx-react";
import userDetail from "Stores/userDetail";
import { openSupportChat } from "Pages/Dashboard/Copilot/agent/agentContract";
import SignalIcon from "./SignalIcon";
import "../agents/agents.scss";

/** Signals are a team flag (Team.signalsEnabled, off unless turned on). Deep Research doesn't depend on it. */
export const signalsOn = () => !!(userDetail?.userFeatureFlag || {}).signalsEnabled;

/** A direct link to Signals with the flag off: one calm line and a way to ask, like Agents. */
export const SignalsOff = () => (
  <div className="ag-page">
    <div className="ag-empty">
      <div className="ag-empty__icon"><SignalIcon id="bolt" size={30} /></div>
      <div className="ag-empty__title">Signals aren’t on for your team yet</div>
      <div className="ag-empty__text">Signals watch your accounts and people for job changes, hiring and buying moves.</div>
      <div className="ag-empty__actions">
        <button className="ag-btn" onClick={openSupportChat}>Ask us to turn them on</button>
      </div>
    </div>
  </div>
);

/** Renders the page when Signals are on for the team, otherwise the off state. */
export const withSignals = Page => observer(props => (signalsOn() ? <Page {...props} /> : <SignalsOff />));

/** Renders children only when Signals are on (account / contact blocks, score column, widgets). */
export const IfSignals = observer(({ children }) => (signalsOn() ? children : null));
